// extracted by css-extract-rspack-plugin
export default {"root":"root--tOFNNm6zkg8Nwpe1"};